import React, { useState, useEffect } from 'react';
//import '../css/CustomerOrderSelection.css'; // Import CSS file for styling
import '../Allcss/CustomerOrderSelection.css';
import Loader from '../loader';
import {
  Box,Checkbox,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  ListSubheader,
  TextField,
  InputAdornment,
  RadioGroup,
  FormControlLabel
} from "@mui/material";

import Switch from '@mui/material/Switch';
import SearchIcon from "@mui/icons-material/Search";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card, Form, Row, Col, Radio } from 'antd';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import CustomButton from '../Reusable/CustomButton';
import { BASE_URL } from "../../App";
const containsText = (text, searchText) =>
  text && String(text).toLowerCase().indexOf(searchText.toLowerCase()) > -1;
function CustomerOrderSelection({ onNext, selectedData }) {
  const [dealer, setDealer] = useState([]);
  const [selectedOption, setSelectedOption] =  useState(selectedData?.selectedOption ||'');
  const [orderType, setOrderType] = useState(selectedData?.orderType || '');
  const [order, setOrder] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dealerOrderTypes, setDealerOrderTypes] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);

  const login_id = localStorage.getItem("LOGIN_ID");
  const branch = localStorage.getItem("BRANCH_CODE");
  const usertype = localStorage.getItem("usertype");
  const [anyLocationChecked, setAnyLocationChecked] = useState(0);

  const handleAnyLocationChange = () => {
    const newValue = !anyLocationChecked;
    const newdata = newValue ? 1 : 0;
    //alert(newdata);
    // console.log('anyLocationChecked:', newValue ? 1 : 0);
    setAnyLocationChecked(newdata);
    console.log('data  check',anyLocationChecked);
  };

  const allOptions = dealer
    ? dealer.map((dealerItem) => ({
      values: {
        DEALER_CODE: String(dealerItem.DEALER_CODE),
        DEALERNAME: String(dealerItem.DEALERNAME),
      },
    }))
    : [];
  const theme = createTheme();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          BASE_URL +"/getdealercode",
          {
            login_id: login_id
          },
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('Token'),
            },
          }
        );

        const dealerData = response.data.DEALER_CODE;
        
        setDealer(response.data.DEALER_CODE);
        setFilteredOptions(response.data.DEALER_CODE.map((dealerItem) => ({
          values: {
            DEALER_CODE: String(dealerItem.DEALER_CODE),
            DEALERNAME: String(dealerItem.DEALERNAME),
          },
        })));

        if (dealerData.length > 0) {
          setSelectedOption({
            values: {
              DEALER_CODE: String(dealerData[0].DEALER_CODE),
              DEALERNAME: String(dealerData[0].DEALERNAME),
            }
          });
        }

        setLoading(false);
      } catch (error) {
        console.error('Error fetching dealer codes:', error);
        setError(error);
        Swal.fire('No Data', 'No data found.', 'error');
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  const dealerCode = selectedOption.DEALER_CODE ;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const formData = new FormData();
        formData.append('dealer_code', dealerCode);
        formData.append('branch_code', branch);
        formData.append('usertype', usertype);
        const response = await axios.post(
          BASE_URL +"/ordertype_new",
          formData,
          {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('Token'),
              'Content-Type': 'multipart/form-data', 
            },
          }
        );
        // const response = await axios.post(
        //   BASE_URL +"/ordertype",
        //   formData,
        //   {
        //     headers: {
        //       Authorization: 'Bearer ' + localStorage.getItem('Token'),
        //       'Content-Type': 'multipart/form-data', 
        //     },
        //   }
        // );
        console.log('Response from API:', response.data);
        setOrder(response.data.ordertypes);
      } catch (error) {
        console.error('Error fetching dealer codes:', error);
        Swal.fire('No Data', 'No data found.', 'error');
        setError(error);
      }
    };
    fetchData();
  }, [dealerCode]);
  const handleOrderTypeChange = (event) => {
    setOrderType(event.target.value);
  };
  console.log('Order Types:', order);
  console.log('Selected Order Type:', orderType);
  const handleDealerSearch = (searchValue) => {
    setSearchText(searchValue);
    const filtered = allOptions.filter((option) =>
      containsText(`${option.values.DEALER_CODE} - ${option.values.DEALERNAME}`, searchValue)
    );
    setFilteredOptions(filtered);
  };
  const handleCustomerChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const handleNext = () => {
    if (selectedOption && orderType ) {
      onNext({ selectedOption, orderType,anyLocationChecked });
    } else {
      alert('Please select customer and order type.');
    }
  };
  if (loading) {
    return <div style={{ justifyContent: 'center', textAlign: 'center', marginTop: '10%' }}><center>
    <Loader />
</center></div>;
  }
  if (error) {
    return <div>Error: {error.message}</div>;
  }
  return (
    <>
      <Card
        bordered={false}
        style={{
          width: '100%',
          textAlign: 'center'
        }}
      >
        <Form>
          <h6 style={{ textAlign: 'left', marginLeft: '50px' }}>DEALER NAME</h6>
          <br></br>
          <Row>
            <Col span={12} style={{ marginLeft: '50px' }}>
              <FormControl fullWidth>
                <InputLabel id="search-select-label">Select Dealer</InputLabel>
                <Select
                  MenuProps={{ autoFocus: false }}
                  labelId="search-select-label"
                  id="search-select"
                  value={selectedOption}
                  label="Options"
                  onChange={handleCustomerChange}
                  onClose={() => setSearchText("")}
                  renderValue={() => selectedOption ? `${selectedOption.values.DEALER_CODE} - ${selectedOption.values.DEALERNAME}` : ''}
                  required={true}
                >
                  <ListSubheader>
                    <TextField
                      size="small"
                      autoFocus
                      placeholder="Type to search..."
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        )
                      }}
                      onChange={(e) => handleDealerSearch(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key !== "Escape") {
                          e.stopPropagation();
                        }
                      }}
                    />
                  </ListSubheader>
                  {filteredOptions.map((option, i) => (
                    <MenuItem key={i} value={option}>
                      {`${option.values.DEALER_CODE} - ${option.values.DEALERNAME}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Col>
          </Row>
          <br /><br />
            <h6 style={{ textAlign: 'left', marginLeft: '50px' }}>ORDER TYPE</h6>
          {selectedOption && ( 
            <>
              {/* <h6 style={{ textAlign: 'left', marginLeft: '50px' }}>ORDER TYPE</h6> */}
              <br />
            
              <Row>
                <Radio.Group onChange={handleOrderTypeChange} value={orderType} required={true}>
                  <Col style={{ marginLeft: '50px' }}>
                    {order.filter(key => key.order_type !== "0")
                        .map((key, value) => (
                          <Radio key={value} value={key.order_type} disabled={key.Active == 1 ? false : true}>
                           
                      
                            {key.order_type}
                            
                          </Radio>
                      ))}
                  </Col>
                </Radio.Group>
             
              </Row>
             
           <br/>
           <h6 style={{ textAlign: 'left', marginLeft: '50px' }}>GLOBAL ORDER</h6>
           <br/>
           <Row>


<FormControlLabel style={{ textAlign: 'left', marginLeft: '50px' }}
 control={
   <Checkbox
     checked={anyLocationChecked}
     onChange={handleAnyLocationChange}
     name="globalBilling"
   />
 }
 label="Global Order"
 sx={{ '& .MuiFormControlLabel-label': { fontSize: '16px' } }}
/>



                
              </Row>
            
            </>
          )}
          <br></br><br></br>
          <ThemeProvider theme={theme}>
            <CssBaseline />
			<center>
			<div className="row">
			
			<div className="col-lg-2">
            <CustomButton
              label="Next"
              onClick={handleNext}
              variant="contained"
              fullWidth
              height={40}
              width="93%"
              borderRadius="8px"
              disabled={!selectedOption || !orderType}
            />
			</div>
			</div>
			</center>
          </ThemeProvider>
        </Form>
      </Card>
    </>
  );
}
export default CustomerOrderSelection;

